
<button mat-icon-button [matMenuTriggerFor]="notificationsMenu"
        (menuOpened)="onMenuOpened()"
        (menuClosed)="onMenuClosed()"
        class="se-header-toolbar-button">
    <mat-icon *ngIf="areActiveMessagesPresent()"
              [matBadge]="getActiveMessageNumber()"
              [matBadgeHidden]="!areActiveMessagesPresent()"
              [matBadgeColor]="getBadgeColor()"
              [@errorAnimation]="isOpen ? 'open' : 'closed'"
              (@errorAnimation.done)="onErrorAnimationDone()"
              matBadgeSize='medium'>notification_important</mat-icon>
    <mat-icon *ngIf="!areActiveMessagesPresent()"
              matBadgeSize='medium'>notifications</mat-icon>
</button>

<mat-menu #notificationsMenu="matMenu" yPosition="below" xPosition="before" class="se-header-notification-menu-panel">
    <div matMenuContent class="se-header-notification-menu-content">
        <mat-card appearance="outlined" *ngIf="getTotalMessageNumber() == 0"
                  class="se-header-notification-card"
                  (click)="onClick($event)">
            <mat-card-header>
                <div mat-card-avatar>
                    <mat-icon>notifications_active</mat-icon>
                </div>
                <mat-card-title translate>Information</mat-card-title>
            </mat-card-header>
            <mat-card-content class="se-header-notification-card-content">
                <p translate>NoNotification</p>
            </mat-card-content>
        </mat-card>
    </div>

    <div matMenuContent class="se-header-notification-menu-content"
         *ngFor="let notification of vnextNotifications" style="overflow-y:auto">
        <mat-card appearance="outlined" class="se-header-notification-card" (click)="onClick($event)">
            <mat-card-header>
                <div mat-card-avatar>
                    <mat-icon [matBadge]="notification.count" [matBadgeHidden]="!!!notification.count" matBadgeColor="accent" matBadgeSize='small'
                              *ngIf="notification.type === 2" class="error-icon">error</mat-icon>
                    <mat-icon [matBadge]="notification.count" [matBadgeHidden]="!!!notification.count" matBadgeColor="accent" matBadgeSize='small'
                              *ngIf="notification.type === 1" class="warning-icon">warning</mat-icon>
                    <mat-icon [matBadge]="notification.count" [matBadgeHidden]="!!!notification.count" matBadgeColor="accent" matBadgeSize='small'
                              *ngIf="notification.type === 0">notifications_active</mat-icon>
                </div>
                <mat-card-title>{{notification.time}} - {{notification.title}}</mat-card-title>
            </mat-card-header>
            <mat-card-content class="se-header-notification-card-content">
                <p style="white-space: pre-line"
                   [class.se-header-notification-card-read]="notification.wasShown">
                    {{notification.message}}
                </p>
            </mat-card-content>
        </mat-card>
    </div>
</mat-menu>
